module.exports = __webpack_public_path__ + "img/third_final_door_coat.35bc81db.webp";